import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    loginWithGoogleSession(sessionId)
      .then(() => {
        toast.success("Signed in with Google");
        navigate("/", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback-page">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto mb-4 rounded-full border-2 border-[#81B29A] border-t-transparent animate-spin" />
        <div className="text-[#6B7B6C] text-sm">Completing sign in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
